<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{
        $t('BUILDINGS.BUILDINGS_MANAGEMENT')
      }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-row>
        <v-col cols="12">
          <v-col cols="12">
            <buildings-list-filters @setFilters="setFilters" />
          </v-col>
        </v-col>
        <v-col cols="12">
          <buildings-list
            :items="items"
            :meta="meta"
            :options.sync="options"
            @show="showedBuilding"
          />
        </v-col>
        <v-col cols="12">
          <export-buildings :options="filters" />
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BuildingsList from '../components/BuildingsList.vue';
import ExportBuildings from '../components/ExportBuildings.vue';
import BuildingsListFilters from '../components/BuildingsListFilters.vue';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'BuildingPage',

  components: {
    BuildingsList,
    ExportBuildings,
    BuildingsListFilters
  },

  mixins: [listOptions],

  computed: {
    ...mapState('building', ['paginationOptions'])
  },

  methods: {
    ...mapActions('building', ['getItemsList']),

    showedBuilding(building) {
      this.$router.push({
        name: 'building_complexes.show',
        params: {
          id: building.building_complex_id,
          selectedBuilding: building
        }
      });
    }
  }
};
</script>
